export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_24-0fb10c9d195b59e4cdbd8cd28368b5a8.jpg";